import React, { Component } from "react";
import FormViewer from "../components/FormViewer";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { checkTranslation, getObject, translate } from "../utils/useful";
import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import moment from "jalali-moment";
import SidebarView from '../components/SidebarView';
import ButtonAnimated from "../components/buttons/ButtonAnimated";
import { nanoid } from "nanoid";
import TableViewer from "../components/TableViewer";
import Header from "../components/header/Header";
import CollectionView from "../windows/Applets/database/CollectionView";
import RecordContentViewer from "./RecordContentViewer";

class RecordViewerModal extends Component {

    state = {

    }

    componentDidMount() {
        // console.log('hereeeeeeeeeeeeeeeeeee3333');
        this.getFrame()
    }


    componentDidUpdate(prevProps) {
        // console.log('hereeeeeeeeeeeeeeeeeee11',this.props.page);
        if (JSON.stringify(this.props.page) != JSON.stringify(prevProps.page)) {
            this.getFrame()
        }
    }


    showModal = () => {
        this.open()
    }

    hideModal = () => {
        // console.log('this.formdata', this.form.getForm())
        // console.log('this.props.initData', this.props.initData)
        // let currentItem = JSON.parse(JSON.stringify(this.form.getForm()))
        // this.props.setData('currentItem', currentItem, 'CollectionView', () => {

        // if (this.props.setData) {
        //     this.props.setData('relevantEdit', false, 'CollectionView')
        // }
        // })
        this.onClose()
        if (this.form) {
            this.form.clearForm()
        }
        setTimeout(() => {
            this.setState({ showModal: false })
        }, 500);
    }

    state = {
        countries: [],
        frame: {},
        // actions: {
        //     submit: { key: "submit", label: "{{lang}}submit", bgColor: this.props.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', color: '#fff', function: this.submitForm, loader: "isPostingData" },
        //     cancel: { key: "cancel", label: "{{lang}}cancel", color: '#777', bgColor: '#e1e1e1', function: this.hideModal },

        // },
        default: { _id: 'details', name: '{{lang}}Details' },
        currentTab: 'details',
        headerConfig: {
            backAction: () => this.hideModal(),
            'title': "View Record",
            // 'subtitle': this.props.page?.subtitle,

        }
    }







    getFrame = () => {

        //    console.log('hereeeeeeeeeeeeeeeeeee');
        HttpServices.request("getFrame", { _id: this.props.page?._id }, (fetchResult, fetchError, status) => {
            // SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

            this.setState({ isLoading: false })

            if (fetchError) { return }

            let frame = fetchResult?.info


            this.setState({ frame: frame }, () => { })

        })
    }


    _handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation()
            this.hideModal()
        }
    }




    submitForm = () => {
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                this.setState({ isPostingData: true })

                if (this.props.setData) {
                    // this.props.setData('relevantEdit', false, 'CollectionView', () => {
                    this.props.submitForm(data, null, () => {
                        this.setState({ isPostingData: false })
                    })
                    // })
                }
            }
        } else {
            this.postValue()
        }
    }

    formNextPage = () => {
        this.form.nextPage()
    }

    formBackPage = () => {
        this.form.backPage()
    }

    open = () => {
        // this.relevantModal.open()
        this.setState({ showModal: true })
        document.addEventListener("keydown", this._handleKeyDown);

    }

    close = () => {
        this.hideModal()
        document.removeEventListener("keydown", this._handleKeyDown);
    }


    onClose = () => {
        setTimeout(() => {
            if (this.props.setData) {
                this.props.setData('currentRelevantTab', 'details', 'CollectionView', () => {
                    this.props.setData('relevantEdit', false, 'CollectionView', () => {
                        this.setState({ showModal: false, currentTab: 'details' })
                    })
                })
            } else {

                this.setState({ showModal: false, currentTab: null }, () => {
                    this.setState({ currentTab: 'details' })
                })
            }
        }, 10);
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    postValue = () => {
        if (this.form) {
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page
            if (data) {
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.key
                this.setState({ isPostingData: true })
                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }
                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {
                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.hideModal()
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })

                    if (!isEditing && this.props.itemAdded) {
                        this.props.itemAdded(fetchResult.info)
                    }
                    if (isEditing && this.props.itemEdited) {
                        if (fetchResult.info) {
                            this.props.itemEdited(fetchResult.info, data._id)
                        } else {
                            this.props.itemEdited(data, data._id)
                        }
                    }
                })
            }
        }
    }

    setFormStatus = (key, value) => {
        this.setState({ [key]: value })
    }

    scrollToTop = () => {
        this.container.scrollTo(0, 0)
    }

    backButton() {
        if (this.state.hasBack) {
            return (
                <div className=" mld-2"  >
                    <div className="" >
                        <LoaderButton
                            onClick={this.formBackPage}
                            text={checkTranslation('Back')}
                            className={"text-bold text-small text-center flexcc w-100 br-20 py-1  " + (this.state.canSubmit ? '' : 'gray-image')}
                            background={'#eee'}
                            width={20}
                            height={20}
                            color={'#777'}
                        />
                    </div>
                </div>
            )
        }
    }

    changeTab = (collection) => {
        console.log('taaaaaaab');
        if (this.state.currentTab != collection._id) {
            this.props.setData('currentRelevantTab', collection._id, 'CollectionView', () => {
                this.setState({ currentTab: collection._id }, () => {
                    if (collection._id != 'details') {
                        this.props.setData('isLoadingData', true, 'CollectionView', () => { })
                    }
                    let search = window.location.search
                    let id = new URLSearchParams(search).get('relevant')
                    let path = [...this.props.windowData?.path]
                    let relevantRecords = []
                    if (collection._id != 'details') {
                        this.props.headers.map((element) => {
                            if (element.type == 'LookupInput') {
                                let value = getObject(this.props.initData, element.key)
                                if (Array.isArray(value)) {
                                    relevantRecords = value
                                }
                                else if (value) {
                                    relevantRecords.push(value)
                                }
                            }
                        })
                        console.log('taaaaaaaaaab3', relevantRecords);
                        this.props.fetchRelevantData(relevantRecords)
                        let variables = this.props.variables
                        variables.currentItem = collection
                        this.setState({ variables })
                        if (id) {
                            path[path.length - 1] = (path[path.length - 1].split('?relevant')[0] + `?relevant=${collection._id}`)
                        }
                        else {
                            path[path.length - 1] = path[path.length - 1] + `?relevant=${collection._id}`
                        }
                    }
                    else {
                        if (id) {
                            path[path.length - 1] = path[path.length - 1].split('?relevant')[0]
                        }
                    }
                    path.splice(0, 2)
                    console.log('taaaaaaaaaab2', path);
                    this.props.changeWindowLink(path)
                })
            })
        }
    }


    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: false,
                    backAction: () => this.hideModal(),
                    'title': "View Record",
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }


    render() {

        if ((this.props.relevantEdit || this.state.showModal || this.props.isMain)) {
            return (
                <div className=" h-100 flex-column window-content-radius" style={{ display: (this.props.relevantEdit || this.state.showModal) ? 'flex' : 'none', position: 'fixed', width: 'calc(100% - 50px)', top: '0px', left: 50, zIndex: 3, backgroundColor: 'rgb(229, 229, 234)' }} width={this.props.width} ref={el => this.relevantModal = el} zIndex={30} hideOverlay={false} isMobile={this.props.isMobile} widthCondition={{ xs: "100%", sm: "70%", md: '60%', lg: "50%", xl: "40%" }} onClosed={this.onClose} >


                    <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} frame={this.state.frame} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                    </div>


                    {(this.state.frame?.relatedFrames?.length > 0 && this.props?.initData?._id) && (
                        <div className="w-100 ">
                            <div className="w-100 flexc py-1 px-2 overflow-auto sc-gray2  " style={{ height: '44px', zIndex: 1, backgroundColor: '#eee', borderBottom: '0px solid #10101005' }}>
                                {/* position: 'sticky', top: 0, */}
                                <button className={" flexcc cursor-pointer py-1  px-2 "} onClick={() => { this.changeTab(this.state.default) }} style={{ borderBottom: this.state.currentTab == this.state.default._id ? `2px solid ${this.props.colors?.primaryColor}` : '', color: this.state.currentTab == this.state.default._id ? this.props.colors?.primaryColor : '#777' }}>
                                    <p className="weight-600 font-size-13 text-center" style={{}}>{checkTranslation(this.state.default.name)}</p>
                                </button>
                                {Array.isArray(this.state.frame?.relatedFrames) && this.state.frame?.relatedFrames.map((collection, index) => {
                                    return (
                                        <button key={index} className={" flexcc cursor-pointer py-1 mrd-2 px-2 "} onClick={() => { this.changeTab(collection) }} style={{ borderBottom: this.state.currentTab == collection._id ? `2px solid ${this.props.colors?.primaryColor}` : '', color: this.state.currentTab == collection._id ? this.props.colors?.primaryColor : '#777' }}>
                                            <p className="weight-600 font-size-13 text-center" style={{ textWrap: 'nowrap' }}>{checkTranslation(collection.name)}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    )}



                    <div className="h-100 w-100 scroll-no-scrollbar" style={{}}>

                        {this.state.currentTab == 'details' && (

                            <RecordContentViewer
                                headers={this.props.headers}
                                pages={this.props.pages}
                                initData={this.props.initData}
                                data={this.props.initData}
                                width={this.props.width}
                                colors={this.props.colors}
                                setHeader={this.setHeader}
                                page={this.props.page}
                                setData={this.props.setData}
                                permissions={this.props.permissions}
                                isMobile={this.props.isMobile}
                                language={this.props.language}
                                frame={this.props.page}
                                submitForm={this.props.submitForm}
                                onClose={this.props.onClose}
                                variables={this.props.variables}
                                itemAdded={this.props.itemAdded}
                                itemEdited={this.props.itemEdited}
                                windowData={this.props.windowData}
                                fetchRelevantData={this.props.fetchRelevantData}
                                changeWindowLink={this.props.changeWindowLink}
                            />
                            // <div className="flexc flex-column w-100 mt-2 px-2">
                            //     <div className="px-2 py-2 br-10 w-100" ref={el => this.container = el} style={{ maxWidth: 800, backgroundColor: '#fff', }}>

                            //         <div className="w-100 mt-2 px-2 pt-2 h-100" style={{ backgroundColor: '#fff', paddingBottom: '10px' }}>
                            //             <FormViewer ref={el => this.form = el} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} setFormStatus={this.setFormStatus} scrollToTop={this.scrollToTop} />
                            //         </div>



                            //         <div className="flexc w-100 px-3 pb-5">
                            //             {Object.values(this.state.actions).map((prop, index) => {
                            //                 if (prop.key == 'submit' && this.state.hasNext) {
                            //                     return (
                            //                         <>
                            //                             {this.backButton()}
                            //                             <div className=" mld-2" key={index}  >
                            //                                 <div className='flexc'>
                            //                                     <ButtonAnimated
                            //                                         iconwidth='24px'
                            //                                         onClick={this.formNextPage}
                            //                                         title={checkTranslation('Next')}
                            //                                         icon='/assets/icons/angle-right-white2.svg'
                            //                                         textColor={prop.color ?? '#000'}
                            //                                         bg={prop.bgColor}
                            //                                         isLoading={this.state[prop.loader]}
                            //                                     />
                            //                                 </div>
                            //                             </div>
                            //                         </>
                            //                     )
                            //                 } else {
                            //                     return (
                            //                         <>
                            //                             {prop.key == 'submit' && (
                            //                                 this.backButton()
                            //                             )}
                            //                             <div className=" mld-2" key={index} >
                            //                                 <div className='flexc'>
                            //                                     {prop.key == 'submit' ? (
                            //                                         <ButtonAnimated
                            //                                             iconwidth='24px'
                            //                                             onClick={prop.function}
                            //                                             title={checkTranslation(prop.label)}
                            //                                             icon='/assets/icons/angle-right-white2.svg'
                            //                                             textColor={prop.color ?? '#000'}
                            //                                             bg={prop.bgColor}
                            //                                             isLoading={this.state[prop.loader]}
                            //                                         />
                            //                                     ) : (
                            //                                         <ButtonAnimated
                            //                                             iconwidth='24px'
                            //                                             onClick={prop.function}
                            //                                             title={checkTranslation(prop.label)}
                            //                                             textColor={prop.color ?? '#000'}
                            //                                             bg={prop.bgColor}
                            //                                             isLoading={this.state[prop.loader]}
                            //                                         />
                            //                                     )}
                            //                                 </div>
                            //                             </div>
                            //                         </>
                            //                     )
                            //                 }
                            //             })}
                            //         </div>

                            //     </div>
                            // </div>
                        )}
                        {Array.isArray(this.props.relevants) && this.props.relevants.map((item, index) => {
                            if (item._id == this.state.currentTab) {
                                return (
                                    <div className="" style={{ height: 'calc(100%)', position: 'relative' }}>
                                        <div className="h-100" style={{ position: 'sticky', top: '0px', zIndex: 1, }}>
                                            <CollectionView
                                                formPages={this.props.pages}
                                                isMobile={this.props.isMobile}
                                                updateUserSettings={this.props.updateUserSettings}
                                                appletAccess={this.props.appletAccess}
                                                functionsHandler={this.props.mainFunctionsHandler}
                                                lastStagePage={this.props.lastStagePage}
                                                // variables={this.props.mainVariables}
                                                goToHub={this.props.goToHub}
                                                changeStage={this.props.changeStage}
                                                language={this.props.language}
                                                headers={item.fields}
                                                automations={this.props.automations}
                                                modules={this.props.modules}
                                                height={this.props.height}
                                                // setHeader={this.props.setHeader}
                                                setData={this.props.setMainData}
                                                updateFrameInfo={this.props.updateFrameInfo}
                                                changePage={this.props.changePage}
                                                changeWindow={this.props.changeWindow}
                                                permissions={this.props.permissions}
                                                permissionLevel={this.props.permissionLevel}
                                                colors={this.props.colors}
                                                page={item}
                                                fieldOptions={this.props.fieldOptions}
                                                tempValue={this.props.tempValue}
                                                updateRecord={this.props.updateRecord}
                                                clearTempValue={this.props.clearTempValue}
                                                data={this.props.isLoadingData ? [] : this.props.relevantData}
                                                top={0}
                                                applet={this.props.applet}
                                                actions={this.props.actionsBtn}
                                                width={this.props.width}
                                                changeValue={this.props.changeValue}
                                                windowData={this.props.windowData}
                                                changeWindowLink={this.props.changeWindowLink}
                                                saveUserSettings={this.props.saveUserSettings}
                                                userSettings={this.props.userSettings}
                                                stackedKey={this.props.stackedKey}
                                                view={this.props.view}
                                                isLoading={this.props.isLoadingData}
                                                setCurrentHead={this.props.setCurrentHead}
                                                currentHead={this.props.currentHead}
                                                initData={this.props.initData}
                                                deleteHeaderField={this.props.deleteHeaderField}
                                                baseUrl={this.props.baseUrl}
                                                // functionsHandler={this.props.functionsHandler}
                                                variables={this.state.variables}
                                                setHeader={this.setHeader}
                                            />
                                        </div>
                                        <div className={"position-absolute"} style={{ bottom: '10px', right: 10, zIndex: 4 }}>
                                            <ButtonAnimated
                                                iconwidth='24px'
                                                onClick={() => { this.props.relevantAddClicked() }}
                                                title='New Record'
                                                icon='/assets/icons/plus-white.svg'
                                                textColor={this.props.colors?.textColor}
                                                invert={this.props.colors?.iconInvert}
                                                bg={this.props.colors?.background}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </div >
            )
        } else {
            return (
                <div></div>
            )
        }
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(RecordViewerModal);